import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'phoenix-alert-dialog',
  template: `
    <div>
      <mat-dialog-content class="pb-0">
        <div id="alert-message" [innerHTML]="data?.message"></div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <div
          [attr.aria-label]="'DilogCancel'"
          class="w-full flex justify-between m-4"
        >
          <button mat-button mat-button mat-dialog-close>Cancel</button>
          <button
            [attr.aria-label]="'dialogAccept'"
            mat-button
            color="primary"
            matButton="filled"
            [mat-dialog-close]="true"
            cdkFocusInitial
          >
            Ok
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  `,
  styles: [],
  standalone: false,
})
export class DialogComponent {
  data = inject(MAT_DIALOG_DATA);
}
